import React from "react";
import { Logo } from "./logo";
import { useNavigate } from "react-router";

export const NavigationDatenschutz = (props) => {

  const navigate = useNavigate();


  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header" >
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
         
          <a className="navbar-brand page-scroll"  onClick={() => navigate("/")} style={{
    display: "flex",
    alignItems: "center", // Vertikale Zentrierung
    justifyContent: "center", // Horizontale Zentrierung (optional)
  }}>
          <Logo logowidth="auto" logoheight={"35px"} />{" "}
             Die Containerklinik
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            
            <li>
              <a   onClick={()=>navigate("/")} className="page-scroll">
                Startseite
              </a>
            </li>
            <li>
              <a  onClick={()=>navigate("/impressum")} className="page-scroll">
                Impressum
              </a>
            </li>
            <li>
              <a href="#page-top"  className="page-scroll">
                Datenschutz
              </a>
            </li>
            
           
          </ul>
        </div>
      </div>
    </nav>
  );
};
